<template>
  <div id="app" @mousemove='updateXY'>
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view>
  </div>
</template>
<script>

  //import Manage from './components/stonghrSysMenu/staffSysManage.vue';
  import '../static/font/font.css';

  export default {
    name: 'App',
    components: {
//    Manage,
    },

    data() {
      return {
        x:'',
        y:'',
        now_x:'',
        now_y:'',
      }
    },

    created() {
      if (localStorage.getItem('theme') == null) {
        localStorage.setItem('theme', '1');
      }
      var address = window.location.href;
      if (address.indexOf("operationDocumentOverall") == -1 && address.indexOf("homeNoLogin") == -1 && address.indexOf("mrecruitInfo") == -1) {
        this.$store.dispatch('findSysOrg');
        this.$store.dispatch('findSysSimpleOrg');
      }


      this.$nextTick(function() {
        this.getIp();
        this.timer = window.setInterval(() => {
          setTimeout(this.getProjectList(), 0);
        }, 60000);
      });
    },

    methods:{
      getProjectList(){
        if (this.now_x!==''&&this.now_x!=='undefined'){
          // if(this.x===this.now_x&&this.y===this.now_y){
            if((this.x - this.now_x)>-10&&(this.x - this.now_x)<10&&(this.y - this.now_y)>-10&&(this.y - this.now_y)<10){
            console.log(this.now_x+"-"+this.now_y+"没动"+"-"+window.location.href)
          }else {
            console.log("差值:"+(this.x - this.now_x));
            this.x = this.now_x;
            this.y = this.now_y;
            console.log(this.now_x+"-"+this.now_y+"动了"+"-"+window.location.href)

            this.$http.post("home/addSysModuleLogDO",{"referer_url":window.location.href,'x':this.x,"now_x":this.now_x}).then((res) => {
              // this.findSysModuleQuickEntranceList = res.data.message;
            });
          }
        }
      },

      getIp() {
        fetch('https://api64.ipify.org?format=json')
          .then(response => response.json())
          .then(data => console.log(data.ip))
          .catch(error => console.error(error));
      },

      updateXY:function(event){
        this.now_x=event.offsetX;
        this.now_y=event.offsetY;
      },
    }
  }
</script>

<style lang="scss">
  * {
    margin: 0;
    padding: 0;
  }

  .viewer-transition {
    z-index: 9999 !important;
  }

  ul li {
    list-style-type: none;
  }

  a {
    text-decoration: none;
  }

  div {
    margin: 0;
    padding: 0;
    border: 0;
    font-size: 100%;
    vertical-align: baseline;
  }

  html, body {
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    background: #F7F8F9;
    margin: 0;
    padding: 0;
    font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "\5FAE\8F6F\96C5\9ED1", Arial, sans-serif;
    /*font-size: 12px;*/
    line-height: 1.5;
  }

  @media (prefers-color-scheme: dark) {
    /* 操作系统及浏览器支持且用户开启了 Dark Mode */
    body {
      background: #000;
      color: white;
    }
  }

  $link-color: #0000cc;
  $primary-color: #409EFF;
  $danger-color: #f56c6c;
  $success-color: #67c23a;
  $warning-color: #e6a23c;
  $info-color: #909399;
  $default-color: #606266;
  #app {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #2c3e50;
    overflow: hidden;
    width: 100%;
    box-sizing: border-box;

    .el-header {
      height: 64px !important;
    }

    .sth-pagination {
      text-align: right;
      margin: 12px 0 12px 0;
    }

    .el-pager li {
      background: #f2f2f2;
      min-width: 24px;
    }

    .el-pagination__jump {
      margin-left: 12px;
      font-weight: 400;
      color: #606266;
    }

    .el-pagination .btn-next, .el-pagination .btn-prev {
      background: center center no-repeat #f2f2f2;
      background-size: 16px;
      cursor: pointer;
      margin: 0;
      color: #303133;
    }

    .cell {
      text-align: center;
    }

    .el-main {
      padding: 28px !important;
    }

    .el-main .divTable .firstColumn .cell {
      text-align: inherit !important;
      padding-left: 32px !important;
    }

    .el-breadcrumb__inner:hover {
      cursor: pointer;
    }

    .el-button--danger.is-plain:hover {
      background: $danger-color;
      border-color: $danger-color;
      color: #fff;
    }

    .el-pager li.active {
      cursor: default;
    }

    .el-cascader-menu__item:hover {
      background-color: #e8f7e8;
    }

  .main-inform {
    margin-top: 8px;
    padding: 12px 20px 1px 12px;
    background: #ffffff;
    border-left: 1px solid #ebeef5;
    border-right: 1px solid #ebeef5
  }

    .has-gutter .cell {
      text-align: center;
      font-weight: bold;
      color: #333;
    }

    thead {
      font-size: 13px;
    }

    .is-leaf .cell {
      color: #333;
    }

    .el-pagination button.disabled {
      color: #c0c4cc;
      background-color: #f2f2f2;
      cursor: not-allowed;
    }

    .el-select-dropdown__item.selected {
      font-weight: 700;
    }

    .el-table td, .el-table th {
      height: 48px;
      min-width: 0;
      text-overflow: ellipsis;
      vertical-align: middle;
      box-sizing: border-box;
    }

    .el-table--medium td, .el-table--medium th {

    }

    .el-table td, .el-table th.is-leaf {
      border-bottom: 1px solid #dfe6ec;
    }


    .el-select-dropdown.is-multiple .el-select-dropdown__item.selected {

      background-color: #fff;
    }

    .el-upload-list__item.is-success .el-upload-list__item-name:focus, .el-upload-list__item.is-success .el-upload-list__item-name:hover {
      cursor: pointer;
    }

    .el-submenu__title:hover {
      background-color: #001529 !important;
    }

    .aaa .el-submenu__title:hover {
      background-color: #001529 !important;
    }

    .light-theme .el-submenu__title:hover {
      background-color: #FFF !important;
    }

    .light-theme .aaa .el-submenu__title:hover {
      background-color: #FFF !important;
    }

    .menu-wrapper .el-menu-item-group ul .el-menu-item:hover {
      background-color: #1d1f26 !important;
    }

    .el-menu--horizontal>.el-submenu .el-submenu__title {
      border-bottom: unset !important;
      background-color: #001529 !important;
    }

    .light-theme .el-menu--horizontal>.el-submenu .el-submenu__title {
      border-bottom: unset !important;
      background-color: #FFF !important;
    }

    .el-menu--horizontal>.el-menu-item {
      border-bottom: unset !important;
    }

    .el-progress-bar__inner {
      position: absolute;
      left: 0;
      top: 0;
      height: 100%;
      text-align: right;
      border-radius: 100px;
      line-height: 1;
    }

    .el-date-table td.today span {
      font-weight: 700;
    }

    .el-message-box .el-button--primary {
      color: #fff;
    }

    .stonghr-maininform-header {
      background: #ffffff;
      padding: 12px 20px 12px 12px;
      margin-top: 16px;
    }

    .stonghr-maininform-header-notitle .el-form {
      padding: 12px 20px 1px 12px;
      background: #ffffff;
    }

    .stonghr-maininform-header-notitle {
      margin-top: 16px;
    }

    .stonghr-form-title {
      padding: 20px 0px 1px 20px;
      background: #fff;
    }

    .stonghr-inner-maininform {

      padding: 0px 30px 50px 30px;
    }

    .clearfix:after {
      content: "";
      display: block;
      height: 0;
      clear: both;
      visibility: hidden;
    }

    .dialog-footer .el-button {
      padding: 10px 15px;
      font-size: 14px;
    }

    .el-dialog__headerbtn {
      font-size: 26px !important;
    }

    .viewer-container {
      z-index: 9999 !important;
    }

    .detaildialog {
      width: 581px;
      margin: 0 auto;
    }

    .detaildialog .el-form-item__label {
      line-height: 20px;
      padding: 0px;
    }

    .detaildialog .el-input.is-disabled .el-input__inner {
      background: #ffffff;
      border-color: #e4e7ed;
      color: #606266;
      cursor: not-allowed;
    }

    .el-textarea__inner {
      border-radius: 0 !important;
    }

    .detaildialog .el-textarea.is-disabled .el-textarea__inner {
      display: block;
      resize: vertical;
      padding: 5px 15px;
      line-height: 1.5;
      box-sizing: border-box;
      width: 100%;
      font-size: inherit;
      color: #606266;
      background-color: #fff;
      background-image: none;
      border: 1px solid #dcdfe6;
      border-radius: 0 !important;
      transition: border-color .2s cubic-bezier(.645, .045, .355, 1);
    }

    .replyimg {
      width: 108px;
      height: 108px;
      border-radius: 0 !important;
    }

    .replyimg img {
      width: 100%;
      height: 100%;
      cursor: pointer;
    }

    .downloadFileTitle {
      cursor: pointer;
      color: #261CDC;
    }

    .addtips {
      color: #666666;
      font-size: 14px;
    }

    .functionpage {
      padding: 30px;
    }

    .functionpage .item {
      background: #ffffff;
      margin-top: 20px;
      padding: 30px 30px;
    }

    .el-menu-vertical-demo {
      overflow-x: auto;
      overflow-y: auto;
      height: calc(100% - 64px);
      background-color: #001529 !important;
    }

    .light-theme .el-menu-vertical-demo {
      overflow-x: auto;
      overflow-y: auto;
      height: calc(100% - 64px);
      background-color: white !important;
    }

    .el-table--medium td, .el-table--medium th {
      padding: 2px 0 !important;
    }

    .el-table__body-wrapper .cell .sthbtn {

    }

    .edit-info {
      padding: 32px 0;
      border: 2px dashed #e1e6eb;
      background: #f8f8f9;
      border-radius: 0 !important;
    }

    .vertical-form-inline {

    }

    .detail_dialog .el-form-item__label {
      padding-bottom: 0px !important;
      line-height: 20px;
    }

    .detail_dialog .el-form-item {
      margin-bottom: 10px !important;
    }

    .el-upload--picture-card {
      width: 108px;
      height: 108px;
      line-height: 108px;
    }

    .sendPic {
      margin-top: 30px;
      border-top: 1px dashed #999999;
      padding-top: 10px;
    }

    //.el-button + .el-button {
    //  margin-left: 4px;
    //}

    .demo-box {
      display: flex;
    }

    .demo-title, .demo-val {
      flex: 1;
      border: 1px solid #909399;
      margin-right: -1px;
      margin-bottom: -1px;
      padding: 6px;
      position: relative;
    }

    .main-inform .el-button + .el-button {
      margin-left: 0px;
    }

    .stonghr-maininform-header-notitle .el-button + .el-button {
      margin-left: 0px;
    }

    .el-badge {
      margin: 5px 0px;
    }

    .el-dialog__body {
      padding: 24px 20px;
      color: #606266;
      font-size: 14px;
    }

    .table-fixed {
      height: 100% !important;
    }

    .el-dropdown-menu {
      min-width: 100px;
    }

    .menu-wrapper .el-menu-item.is-active:after {
      content: '';
      display: block;
      width: 4px;
      position: absolute;
      top: 0;
      bottom: 0;
      right: 0;
    }

    .menu-wrapper .el-menu-item-group ul .el-menu-item {
      background-color: #262832 !important;
      padding-left: 56px !important;
    }

    .el-menu-item-group .el-menu-item-group__title {
      padding: 0px;
    }

    .toggleMen-icon {
      font-size: 22px !important;
    }

    .el-divider--horizontal {
      display: block;
      height: 1px;
      width: 100%;
      margin: 24px 0;
    }

    .el-divider--vertical {
      width: 1px;
      vertical-align: middle;
      background: rgba(0, 0, 0, 0.15)
    }

    .el-divider {
      background-color: #dcdfe6;
      position: relative;
    }

    .link-color {
      color: $link-color;
    }

    .danger-color {
      color: $danger-color;
    }

    .success-color {
      color: $success-color;
    }

    .warning-color {
      color: $warning-color;
    }

    .info-color {
      color: $info-color;
    }

    .default-color {
      color: $default-color;
    }

    .cursor-pointer {
      cursor: pointer;
    }

    .danger-text-button {
      @extend .danger-color;

      &:hover {
        color: #f78989 !important;
      }
    }

    .success-text-button {
      @extend .success-color;

      &:hover {
        color: #85ce61 !important;
      }
    }

    .info-text-button {
      @extend .info-color;

      &:hover {
        color: #a6a9ad !important;
      }
    }

    .default-text-button {
      @extend .default-color;
    }

    .el-table {
      .warning-row {
        background: oldlace;
      }

      .error-row {
        //  background: #fbc4c4;
        background: #fef0f0;
      }

      .error {
        background: #ece8dd;
      }
    }

    .nowrapcellTable .cell {
      overflow: hidden !important;
      white-space: pre !important;

    }

    .table-tips {
      padding-left: 45px;
      font-weight: bold;
      background: #ffffff;
      font-size: 14px;
      border-top: 1px solid #dfe6ec;
      border-left: 1px solid #ebeef5;
      padding: 6px 0px 6px 45px
    }

    .table_box {
      height: 40px;
      line-height: 18px;
      font-size: 14px;
    }

    .table_val {
      font-size: 13px;
    }

    .el-table .cell, .el-table th div, .el-table--border td:first-child .cell, .el-table--border th:first-child .cell {
      padding-left: 2px;
    }

    .sth-detail-table {
      border-spacing: 0 !important;
      border: 1px solid #e6eaee;
      border-right: none;
      padding: 0;
      margin: 0;
      border-collapse: collapse;
    }

    .el-table .cell {
      padding-left: 2px;
      padding-right: 2px;
      line-height: 18px;
    }

    .sth-detail-table-cell-title {
      background-color: #eff3f6;

    }

    .cell-title {
      background-color: #eff3f6;

    }

    .sth-table-row {
      margin: 0;
      padding: 0;
      border: 0;
      vertical-align: baseline;
      color: #606266;
      font-size: 12px;
    }

    .sth-table-column {
      /*padding: 6px 0 !important;*/
      border-bottom: 1px solid #e6eaee;
      border-right: 1px solid #e6eaee;
      height: 30px;
      min-width: 0;
      text-overflow: ellipsis;
      vertical-align: middle;
      box-sizing: border-box;
    }

    .sth-table-cell {
      text-align: left;
      box-sizing: border-box;
      white-space: normal; //规定段落中的文本不进行换行：
      word-break: break-all; //允许在单词内换行

      padding-right: 8px;
      padding-left: 8px;
      overflow: hidden;
      text-overflow: ellipsis; //显示省略符号来代表被修剪的文本
      font-size: 12px;
    }

    .el-form-item--mini.el-form-item, .el-form-item--small.el-form-item {
      // margin-bottom: 12px;
    }

    .el-table th {
      background: #f5f7fa;
    }

    .el-table {
      font-size: 12px;
    }

    .el-pagination .el-select .el-input .el-input__inner {
      padding-right: 25px;
      border-radius: 0 !important;
      height: 28px;
    }

    .sth-searchForm .el-select, .sth-searchForm .el-input {
      width: 188px;
    }
  }

  .icon {
    width: 14px;
    height: 14px;
    vertical-align: -0.15em;
    fill: currentColor;
    overflow: hidden;
    padding-right: 5px !important;
    padding-left: 5px !important;
  }

  .el-loading-mask {
    position: absolute;
    z-index: 3000;
    background-color: rgba(255, 255, 255, .9);
    margin: 0;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    -webkit-transition: opacity .3s;
    transition: opacity .3s;
  }

  .rowTableD {
    border: 1px solid #e6eaee;
  }

  .el-aside .el-submenu {
    user-select: none;
    background-color: #001529 !important;
  }

  .light-theme .el-aside .el-submenu {
    user-select: none;
    background-color: white !important;
  }

  .el-tag {
    border-radius: 0 !important;
  }

  .el-menu--horizontal > .el-submenu.is-active .el-submenu__title {
    border-bottom: unset !important;
  }

  .light-theme .el-aside .el-submenu.is-active .el-submenu__title {
    color: #000 !important;
  }

  .el-menu-item.is-active {
    color: #FFF !important;
    background-color: #33F !important;
  }

  .light-theme .el-aside .el-menu-item.is-active {
    color: #33F !important;
    background-color: #F0F5FF !important;
    border-right: 2px solid #33F !important;
  }

  #app .light-theme .el-aside .el-menu-item.is-active:hover {
    color: #33F !important;
    background-color: #F0F5FF !important;
  }

  #app .el-menu-item {
    height: 64px !important;
    line-height: 64px !important;
    padding: 0 18px !important;
  }

  #app .el-menu--horizontal .el-menu-item:hover {
    background-color: unset !important;
  }

  #app .el-aside .el-menu-item:hover {
    height: 64px !important;
    line-height: 64px !important;
    padding: 0 18px !important;
    color: #99A1A9;
    background-color: #33F;
  }

  #app .el-menu-item {
    height: 64px !important;
    line-height: 64px !important;
    padding: 0 18px !important;
    color: #99A1A9;
    background-color: #001529;
  }

  #app .light-theme .el-aside .el-menu-item:hover {
    height: 64px !important;
    line-height: 64px !important;
    padding: 0 18px !important;
    color: #787878 !important;
    background-color: #F0F5FF;
  }

  #app .light-theme .el-menu-item {
    height: 64px !important;
    line-height: 64px !important;
    padding: 0 18px !important;
    color: #787878;
    background-color: #FFF;
  }

  #app .el-submenu__title {
    height: 64px !important;
    line-height: 64px !important;
    padding: 0 18px !important;
    color: #99A1A9;
  }

  #app .light-theme .el-submenu__title {
    height: 64px !important;
    line-height: 64px !important;
    padding: 0 18px !important;
    color: #787878 !important;
  }

  //#app .el-aside .el-menu-item:hover:not(.is-active), #app .el-aside .el-submenu__title:hover:not(.is-active) {
  //  background-color: #33F !important;
  //}

  .el-menu-item:hover:not(.is-active), #app .el-aside .el-submenu__title:hover:not(.is-active) {
    background-color: #33F !important;
    color: #99A1A9;
  }

  .light-theme .el-menu-item:hover:not(.is-active), #app .light-theme .el-aside .el-submenu__title:hover:not(.is-active) {
    background-color: #F0F5FF !important;
  }

  .el-submenu__title:hover {
    background-color: #33F !important;
  }

  .staffInformation .staffInformation-container .staffInfo-nav .el-menu--horizontal > .el-menu-item {
    color: #495060 !important;
  }

  .el-menu-item {
    padding: 0 18px !important;
  }

  .light-theme .el-menu-item {
    background-color: white !important;
    padding: 0 18px !important;
  }

  .el-menu--horizontal > .el-menu-item.is-active {
    background-color: unset !important;
  }

  .el-menu--popup {
    padding: 0 !important;
  }

  .el-button {
    border-radius: 0 !important;
  }

  .el-button:hover {
    border-radius: 0 !important;
  }

  .el-button:focus {
    border-radius: 0 !important;
  }

  .el-input .el-input__inner {
    border-radius: 0 !important;
  }

  .el-input__inner {
    border-radius: 0 !important;
  }

  .el-input-group__append, .el-input-group__prepend {
    border-radius: 0 !important;
    padding-left: 11px;
    padding-right: 11px;
    background: #FAFAFA;
  }

  .el-card {
    border-radius: 0 !important;
  }

  .el-card__header {
    padding: 8px 20px !important;
  }

  #app .el-pagination .btn-next, #app .el-pagination .btn-prev {
    background: center center no-repeat #F7F8F9;
  }

  #app .el-pager li {
    background: #f7f8f9;
  }

  .el-upload-dragger {
    border-radius: 0 !important;
    width: 540px;
  }

  .el-tooltip__popper {
    max-width:30%
  }

  .el-message-box {
    border-radius: 0 !important;
  }

  .el-popover {
    border-radius: 0 !important;
    text-align: start;
  }

  .el-breadcrumb__inner {
    cursor: auto !important;
  }

  //intro插件的样式修改
  .introjs-tooltip {
    border-radius: 0 !important;
  }
  .introjs-helperLayer {
    box-shadow: rgba(33, 33, 33, 0.8) 0 0 0 0, rgba(33, 33, 33, 0.5) 0 0 0 5000px !important;
  }
  .introjs-skipbutton {
    font-size: unset !important;
    padding: 0 !important;
  }
  .introjs-tooltip-header {
    padding: 10px 10px 0 10px !important;
  }
  .introjs-tooltiptext {
    padding: 0 20px 20px 20px !important;
  }
  .introjs-tooltipbuttons {
    padding: 10px 20px 10px 20px !important;
  }
  .introjs-button {
    padding: 3px 8px !important;
    border: 1px solid #ADADFF !important;
    text-shadow: none !important;
    font-size: 12px !important;
    color: #33F !important;
    background-color: #EBEBFF !important;
    border-radius: 0 !important;
  }
  .introjs-button:focus {
    text-decoration: none !important;
    background-color: #EBEBFF !important;
    -webkit-box-shadow: none !important;
    box-shadow: none !important;
    border: 1px solid #ADADFF !important;
    color: #33F !important;
  }
  .introjs-button:hover {
    padding: 3px 8px !important;
    border: 1px solid #33F !important;
    text-shadow: none !important;
    font-size: 12px !important;
    color: #FFF !important;
    background-color: #33F !important;
    border-radius: 0 !important;
  }
  .introjs-disabled {
    padding: 3px 8px !important;
    border: 1px solid #9E9E9E !important;
    text-shadow: none !important;
    font-size: 12px !important;
    color: #FFF !important;
    background-color: #9E9E9E !important;
    border-radius: 0 !important;
  }
  .introjs-disabled:hover {
    padding: 3px 8px !important;
    border: 1px solid #9E9E9E !important;
    text-shadow: none !important;
    font-size: 12px !important;
    color: #FFF !important;
    background-color: #9E9E9E !important;
    border-radius: 0 !important;
  }

  //右上角红点样式
  .el-badge__content.is-fixed.is-dot {
    margin: 8px 0 4px 0 !important;
  }


//——————————————————————————————————————————————————————————————————————————————————————————————————————————————————————

//以下是页面标准化样式代码，修改覆盖样式请写在上面

  //Tab页面切换按钮的样式
  .tab-select-class {
    border-color: #33F !important;
    border-width: 1px;
    background-color: #EBEBFE;
    z-index: 1;
  }

  //Tab页面切换按钮hover时边框颜色
  .sth-breadcrumb .el-button:hover {
    border-color: initial !important;
  }

  //横排副轴居中左对齐flex样式
  .row-center-flex-style {
    display: flex;
    flex-direction: row;
    align-items: center;
    align-content: flex-start;
  }

  //面包屑外层div样式
  .sth-breadcrumb {
    padding-top: 25px;
    padding-left: 28px;
    height: 39px;
    background: #ffffff;
    margin: -28px -28px 28px;
    -moz-user-select: none;
    -webkit-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }

  //更多搜索按钮的样式
  .search-button {
    height: 32px;
    background: #FAFAFA;
    width: 32px;
    vertical-align: center;
  }

  //搜索按钮中图标的样式
  .search-button-img {
    margin-top: 5px
  }

  //搜索框样式
  .table-search-style {
    width: 218px !important;
  }

  //更多搜索按钮中图标的样式
  .moreSearch-button-img {
    margin-left: -8px;
    margin-top: -2px;
  }

  //表格顶部刷新、排序、批量等操作按钮分割线样式
  .table-operation-divider-style {
    height: 16px;
  }

  //表格顶部刷新图标的样式
  .reload-button-img {
    margin-top: 5px;
  }

  //表格区块主体样式
  .main-table-block-style {
    padding: 28px;
    background-color: #FFF;
  }

  //更多搜索弹出框中元素的样式
  .search-condition {
    display: inline-block;
    -ms-flex-align: center;
    align-items: center;
    margin-right: 28px;
    margin-bottom: 28px;
  }

  //标准（最多四字）按钮长度样式，HandleBar中自动绑定
  .handle-condition .el-button {
    width: 80px;
  }

  .handle-condition .el-button.is-loading {
    width: 97px;
  }

  .search-condition .el-button {
    width: 80px;
  }

  .search-condition .el-button.is-loading {
    width: 97px;
  }

  //六字按钮长度样式
  .five-button-style {
    width: 98px !important;
  }

  //六字按钮长度样式
  .six-button-style {
    width: 104px !important;
  }

  //七字按钮长度样式
  .seven-button-style {
    width: 110px !important;
  }
  //十字按钮长度样式
  .ten-button-style {
    width: 160px !important;
  }

  //七字按钮长度样式
  .nine-button-style {
    width: 110px !important;
  }

  //带图标的四字按钮长度样式
  .more-button-style {
    width: 92px !important;
  }

  //下拉框、输入框标准长度，自动绑定
  .search-condition .el-input .el-input__inner {
    width: 250px;
  }

  //日期下拉框标准长度，自动绑定
  .search-condition .el-date-editor {
    width: 250px;
  }

  //logo切换样式
  .logo-change {
    padding-left: 4px;
    transition: all 0.3s ease-in-out 0s;
  }

  //对话框标题样式
  .dialog-title {
    padding-left: 10px;
    color: #33f;
  }

  //移动端样式
  .weui-btn {
    border-radius: 0 !important;
  }

  .weui-btn_primary {
    background-color: #33f !important;
  }

  .weui-btn:after {
    border-radius: 0 !important;
  }

  .weui-dialog__btn_primary {
    color: #33f !important;
  }

  body .el-table th.gutter{
    display: table-cell!important;
  }

</style>



// WEBPACK FOOTER //
// src/App.vue